import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

// Connects to data-controller="icon-navigation"
export default class extends Controller {
	static values = {
		statusModalKlein: "closed", // Initialwert für statusModalKlein
		currentItemIndex: -1, // Initialwert für currentItemIndex
	}

	static targets = ["modalKlein", "item"]

	connect() {}

	close() {
		this.unselectItems()
		this.closeModalKlein()
	}

	// Wenn ein Modal-Klein dem Dom hinzugefügt wird wird es eingeblendet
	modalKleinTargetConnected() {
		this.openModalKlein()
	}

	// hide modal on successful form submission
	// action: "turbo:submit-end->icon-navigation#submitEnd"
	submitEnd(event) {
		if (event.detail.success) this.close()
	}

	// Schließt das Navigationselement, wenn außerhalb davon oder eines Navigationselements geklickt wird
	closeByClick(event) {
		if (!this.hasModalKleinTarget) return

		// Wenn das Clickevents durch Klick auf ein Punkt im Chart ausgelöst wurde, dann soll dieser ignoriert werden.
		if (event.defaultPrevented) return

		// Innerhalb des ModalKlein wurde geclickt
		if (this.modalKleinTarget.contains(event.target)) return

		// Wenn nicht innerhalb des Icon Navigation Controller Scope geclickt wurde
		if (!this.element.contains(event.target)) return

		// Überprüft, ob das Klickereignis von einem der Navigationsmenüelemente ausgelöst wurde
		const clickedNavItem = this.itemTargets.some((item) => item.contains(event.target))

		// Innerhalb des Modal Neu wurde geclickt
		const clickedModalNeu = document.querySelector("#modal_neu")?.contains(event.target)

		// Schließt den Navigation-Container, wenn außerhalb des Navigation-Containers oder eines Navigationselements geklickt wurde
		if (!clickedNavItem && !clickedModalNeu) this.close()
	}

	// Private Methods

	// Diese Methode wird nur von ItemTargets aufgerufen
	// Wenn man auf ein Item klick, dann soll das selectiert, also aktiv werden, ist das Item bereits aktiv gewesen wird es unselected
	click(event) {
		const itemIndex = this.itemTargets.indexOf(event.currentTarget)

		this.unselectItems() // Alle Items unselecten

		if (itemIndex === this.currentItemIndexValue) {
			// Click auf ein AKTIVES Item
			this.closeModalKlein()
			event.preventDefault() // Der Link des Items soll nicht ausgeführt werden, wenn es unselected wird
		} else {
			// Click auf ein INAKTIVES Item
			this.selectItem(event.currentTarget)
		}
	}

	selectItem(item) {
		if (!item) return

		this.currentItemIndexValue = this.itemTargets.indexOf(item)
		item.dataset.ui = "aktiv"
	}

	unselectItems() {
		this.itemTargets.forEach((item) => item.removeAttribute("data-ui"))
	}

	openModalKlein() {
		if (this.statusModalKleinValue === "open") {
			// ModalKlein ohen Animation sichtbar machen (wenn man von einem Icon auf ein anderes wechselt).
			this.modalKleinTarget.classList.remove("hidden")
		} else {
			this.statusModalKleinValue = "open"
			enter(this.modalKleinTarget)
		}
	}

	closeModalKlein() {
		if (this.statusModalKleinValue === "closed") return
		this.statusModalKleinValue = "closed"
		this.currentItemIndexValue = -1

		if (!this.hasModalKleinTarget) return
		leave(this.modalKleinTarget).then(() => {
			this.modalKleinTarget.remove()
		})
	}
}
